import { $ } from '@/libs/jquery/index'
import 'slick-carousel/slick/slick.min'
import URI from 'urijs'

export const baseSelector = '[data-selector="slickHeader"]'

interface ISlickDisplayOptions {
  appendArrows?: string
  autoplay?: boolean
  autoplaySpeed?: number
  cssEase?: string
  dots?: boolean
  draggable?: boolean
  fade?: boolean
  infinite?: boolean
  nextArrow?: string
  pauseOnFocus?: boolean
  pauseOnHover?: boolean
  prevArrow?: string
  slidesToScroll?: number
  slidesToShow?: number
  speed?: number
}

const autoplayPreset = {
  autoplay: true,
  fade: false,
  nextArrow: '<button type="button" class="slick-next"></button>',
  pauseOnFocus: true,
  pauseOnHover: true,
  prevArrow: '<button type="button" class="slick-prev"></button>',
}

export class SlickCarousel {
  public selectors: ISelectors = {
    base: baseSelector,
    cases: '[data-selector="slickCases"]',
    casesCounter: '[data-selector="slickCasesCounter"]',
    casesCurrent: '[data-selector="slickCasesCurrent"]',
    casesItem: '[data-selector="slickCasesItem"]',
    casesNav: '[data-selector="slickCasesNav"]',
    partners: '[data-selector="slickPartners"]',
    partnersNav: '[data-selector="slickPartnersNav"]',
    products: '[data-selector="slickProducts"]',
    sidebar: '[data-selector="slickSidebar"]',
    sidebarNav: '[data-selector="slickSidebarNav"]',
  }

  constructor() {
    $(() => {
      this.initSlick($(this.selectors.base), {})
      this.initPartnersSlick()
      this.initCasesSlick()
      this.initSidebarSlick()
      this.initProductSlider()
    })
  }

  private initSlick($selector: JQuery, options: ISlickDisplayOptions): void {
    const {
      appendArrows = '.slider__arrows',
      autoplay = false,
      autoplaySpeed = 0,
      cssEase = 'linear',
      dots = false,
      draggable = false,
      fade = true,
      infinite = true,
      pauseOnFocus = false,
      pauseOnHover = false,
      slidesToScroll = 1,
      slidesToShow = 1,
      speed = 500,
    } = options

    $selector.slick({
      appendArrows,
      autoplay,
      autoplaySpeed,
      cssEase,
      dots,
      draggable,
      fade,
      infinite,
      pauseOnFocus,
      pauseOnHover,
      slidesToScroll,
      slidesToShow,
      speed,
    })
  }

  private initPartnersSlick(): void {
    $(this.selectors.partners).each((index, elem) => {
      const $slider = $(elem)
      const amount = $slider.data('sliderAmount') || 5
      const defaultWidth = $slider.width()

      this.initSlick($slider, {
        ...autoplayPreset,
        appendArrows: this.selectors.partnersNav,
        autoplaySpeed: 2000,
        slidesToScroll: amount,
        slidesToShow: amount,
      })

      $slider.css('width', defaultWidth).show()
    })
  }

  private initCasesSlick(): void {
    $(this.selectors.cases).each((index, elem) => {
      const $slider = $(elem)
      const autoplay = !!$slider.data('sliderPlay') || false
      const dots = !!$slider.data('sliderDots') || false
      const defaultWidth = $slider.width()

      if (!dots) {
        $(this.selectors.casesCounter).html($slider.find(this.selectors.casesItem).length.toString())
      }

      this.initSlick($slider, {
        ...autoplayPreset,
        appendArrows: this.selectors.casesNav,
        autoplay,
        autoplaySpeed: 2000,
        dots,
      })

      $slider.css('width', defaultWidth).show()

      if (!dots) {
        $slider.on('afterChange', (event, slick, currentSlide) => {
          $(this.selectors.casesCurrent).html(currentSlide + 1)
        })
      }
    })
  }

  private initSidebarSlick(): void {
    $(this.selectors.sidebar).each((index, elem) => {
      const $slider = $(elem)
      const defaultWidth = $slider.width()

      this.initSlick($slider, {
        ...autoplayPreset,
        appendArrows: this.selectors.sidebarNav,
        autoplaySpeed: 15000,
        draggable: true,
      })

      $slider.css('width', defaultWidth).show()
    })
  }

  private initProductSlider(recipient: string = '', query: string = ''): void {
    const $products = $(this.selectors.products)
    if ($products.length > 0) {
      this.initSlick($products, {
        autoplay: true,
        autoplaySpeed: 3000,
        dots: true,
        fade: false,
      })

      this.filterProductSlick($products)
    }
  }

  private filterProductSlick($products: JQuery): void {
    const recipient: string = URI.parseQuery(window.location.search).recipient || ''
    const query: string = URI.parseQuery(window.location.search).q || ''
    if (recipient && (!query || $('[data-selector="slide-lead"]').length === 0)) {
      if (recipient.split(',').length === 1) {
        $products.slick('slickFilter', `[data-selector="slide-${recipient}"]`)
      } else {
        $products.slick('slickFilter', '.js-slide-products')
      }
    } else if (!recipient && !query) {
      $products.slick('slickFilter', '[data-selector="slide-b2b"]')
    } else if (query && recipient && $('[data-selector="slide-lead"]').length > 0) {
      $products.slick('slickFilter', '[data-selector="slide-lead"]')
    }
  }
}
